import BaseModule from "@/components/site-builder/BaseModule";
import TextField from "@/components/site-builder/TextField";
import type { FileDownloadModuleType } from "./types";
import DownloadButton from "./DownloadButton";
import LayoutVariant1 from "./LayoutVariant1";
import Thumbnail from "./Thumbnail";

export interface FileDownloadModuleProps {
  module: FileDownloadModuleType;
}

export default function FileDownloadModule(props: FileDownloadModuleProps) {
  const { module } = props;
  const {
    body: {
      title,
      description,
      ctaLabel,
      file,
      thumbnail,
      layout,
      showThumbnailCaption,
    },
  } = module;

  const thumbContent = (
    <Thumbnail thumbnail={thumbnail}>
      {showThumbnailCaption && <TextField field={title} type="header-h2" />}
    </Thumbnail>
  );

  return (
    <BaseModule module={module}>
      <LayoutVariant1 layout={layout} thumbContent={thumbContent}>
        {!showThumbnailCaption && <TextField field={title} type="header-h2" />}
        <DownloadButton fileName={file.filename}>{ctaLabel}</DownloadButton>
        <TextField field={description} type="text-large" />
      </LayoutVariant1>
    </BaseModule>
  );
}
